const ITEMS = [
    "CFTV 4K",
    "Controle de acesso facial",
    "Portões e automação",
    "Suporte e manutenção 24/7",
    "Condomínios",
    "Residências",
];

const Row = ({ ariaHidden }) => (
    <div aria-hidden={ariaHidden} className="flex shrink-0 items-center">
        {ITEMS.map((item, i) => (
            <span key={i} className="flex items-center">
                <span
                    className={`font-display text-xl sm:text-2xl font-bold uppercase tracking-wide whitespace-nowrap ${
                        i % 2 === 0 ? "text-slate-200" : "text-slate-500"
                    }`}
                >
                    {item}
                </span>
                <span className="mx-8 h-2 w-2 rotate-45 bg-volt/70" />
            </span>
        ))}
    </div>
);

const Marquee = () => (
    <div
        data-testid="marquee-ticker-wrapper"
        className="relative overflow-hidden border-y border-white/10 bg-panel/60 py-6"
    >
        <div className="marquee-track flex w-max">
            <Row ariaHidden={false} />
            <Row ariaHidden={true} />
        </div>
        <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-ink to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-ink to-transparent" />
    </div>
);

export default Marquee;
